import { render, staticRenderFns } from "./P0104.vue?vue&type=template&id=4862bea8&"
import script from "./P0104.vue?vue&type=script&lang=ts&"
export * from "./P0104.vue?vue&type=script&lang=ts&"
import style0 from "./P0104.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports